import styled from 'styled-components';
import Lab121 from 'dc/Lab121';
import { Ico20 } from 'dc/Ico';

type ActivitiesLabelProps = {
  $marginBottom?: string;
};

export const ActivitiesLabel = styled.div<ActivitiesLabelProps>`
  position: relative;
  align-items: center;
  background-color: #f4f7f9;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  margin-bottom: ${props => (props.$marginBottom ? props.$marginBottom : 0)};
`;

export const ActivitiesTitle = styled(Lab121)``;

export const ActivitiesInfoIcon = styled(Ico20)`
  color: #90a4ae;
  cursor: pointer;
`;
